<script>
    import { onMount } from 'svelte'
    import End from 'views/pages/activities/show/types/selfAssessment/End.svelte'
    import SelfAssessmentUtil from 'views/pages/activities/show/types/selfAssessment/SelfAssessmentUtil';
    import Start from 'views/pages/activities/show/types/selfAssessment/Start.svelte'
    import TaskGroup from 'views/pages/activities/show/types/selfAssessment/TaskGroup.svelte'

    const {
        model
    } = $props()

    let selectedLearningGoals = $state([])
    let activePage = $state('start')
    let taskGroupModel = $state(null)
    // 'make' | 'review'
    let mode = $state('make')

    onMount(() => {
        Backbone.View.menubar.setPreferredSize('small')
        Backbone.View.header.clearButtons()
        Backbone.View.header.setTitle()
        Backbone.View.header.setCrumblepath(
            model.getAllCrumblepathModels(),
            'show'
        )
        return () => {
            Backbone.View.menubar.setPreferredSize()
            model.set('show_answers', false)
        }
    })

    function onStartCallback() {

        mode = 'make'
        model.set('show_answers', false)

        if (ACL.checkRole(ACL.roles.TEACHER)) {
            setNextTaskGroup()
            return
        }

        jQuery.post({
            url: '/self_assessment/reset_progress',
            data: {
                activity_id: model.id,
                self_assessment_id: model.get('self_assessment').id,
                self_assessment_learning_goal_ids: selectedLearningGoals
            },
            success: () => {
                for (const learningGoalId of selectedLearningGoals) {
                    SelfAssessmentUtil.removeResponsesForLearningGoal(learningGoalId, model)
                }
                setNextTaskGroup()
            }
        })

    }

    function onReviewCallback() {

        mode = 'review'
        model.set('show_answers', true)
        setNextTaskGroupForReview()
    }

    function onNextTaskGroupCallback() {

        if (mode === 'review') {
            setNextTaskGroupForReview()
            return
        }

        // Continue if all responses are saved. We need a score from backend
        if (model.responses.every(response => response.get('saved_state') === 'server')) {
            setNextTaskGroup()
            return
        }

        // Monitor responses saved_state until all responses are saved to server
        const onSavedStateChanged = () => {
            if (model.responses.every(response => response.get('saved_state') === 'server')) {
                model.responses.off('change:saved_state', onSavedStateChanged)
                setNextTaskGroup()
            }
        }
        model.responses.on('change:saved_state', onSavedStateChanged)
    }

    function setNextTaskGroupForReview() {

        const nextTaskGroup = SelfAssessmentUtil.getNextTaskGroupForReview(
            model, taskGroupModel?.id
        )

        if (nextTaskGroup) {
            taskGroupModel = nextTaskGroup
            activePage = 'taskgroup'
        } else {
            // Walked every reviewable task group in the activity. Return to start
            // rather than the End screen, which is keyed off selectedLearningGoals
            // and only makes sense for the make flow.
            taskGroupModel = null
            mode = 'make'
            activePage = 'start'
            model.set('show_answers', false)
        }
    }

    function setNextTaskGroup() {

        // Teachers go through all task groups, because we don't have responses to do calculations
        if (ACL.checkRole(ACL.roles.TEACHER)) {
            const nextTaskGroup = SelfAssessmentUtil.getNextTaskGroupForTeacher(
                selectedLearningGoals, model, taskGroupModel?.id
            )

            if (nextTaskGroup) {
                taskGroupModel = nextTaskGroup
                activePage = 'taskgroup'
            } else {
                activePage = 'end'
                taskGroupModel = null
            }
        }

        if (ACL.checkRole(ACL.roles.STUDENT)) {
            for (const learningGoalId of selectedLearningGoals) {

                // If the goal is achieved, go to the next goal
                if (SelfAssessmentUtil.isLearningGoalAchieved(learningGoalId, model)) {
                    continue
                }

                // Check if a next task group is available for the goal
                const nextTaskGroup = SelfAssessmentUtil.getNextTaskGroupForLearningGoal(learningGoalId, model)
                if (nextTaskGroup) {
                    taskGroupModel = nextTaskGroup
                    activePage = 'taskgroup'
                    return
                }
            }

            activePage = 'end'
            taskGroupModel = null
        }
    }
</script>

{#if activePage === 'start'}
    <Start
        activityModel={model}
        {onStartCallback}
        {onReviewCallback}
        bind:selectedLearningGoals>
    </Start>
{:else if activePage === 'taskgroup'}
    {#key taskGroupModel.id}
        <TaskGroup
            {onNextTaskGroupCallback}
            activityModel={model}
            {taskGroupModel}
            {mode}>
        </TaskGroup>
    {/key}
{:else if activePage === 'end'}
    <End activityModel={model} {selectedLearningGoals} {onReviewCallback}></End>
{/if}
